import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { CourseSection } from 'src/app/model/course-section';

@Injectable({
  providedIn: 'root'
})
export class CoursesectionEntityService  extends EntityCollectionServiceBase<CourseSection> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('CourseSection', serviceElementsFactory);
  }
}
